// LoginForm.js
import React, { useContext, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { Alert } from "antd";
import { userLogin } from "../../../api";
import { REGEX, SHOW_TOAST, STORAGE_KEY, STRINGS } from "../../../constants";
import AppButton from "../../../components/button/AppButton";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../../context";
import { IMAGES } from "../../../assets";
import IconTint from "react-icon-tint";

const LoginForm = () => {
  const [loginState, setLoginState] = useState({
    open: false,
    loader: false,
    error: "",
    passwordHideShow: false,
  });

  const { setUser, setForgetPassStatus } = useContext(AuthContext);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const initialValues = {
    auth_type: "manual",
    email: "",
    password: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .matches(REGEX.emailRegex, t(STRINGS.please_enter_valid_email))
      .required(t(STRINGS.please_enter_email)),
    password: Yup.string()
      // .matches(
      //   /^(?=.*[a-z])(?=.*[0-9])(?=.*[A-Z])(?=.*[!@#%&]).{8,}$/,
      //   "Password must be at least 8 characters long with 1 number, 1 uppercase letter, 1 lowercase letter and 1 special character"
      // )
      .required(t(STRINGS.please_enter_password)),
  });

  const onSubmit = async (values, { resetForm }) => {
    setLoginState((prev) => ({ ...prev, loader: true }));
    const params = {
      emailId: values?.email?.toLowerCase(),
      password: values?.password,
    };
    const result = await userLogin(params);

    if (result?.status) {
      if (result?.data?.body?.userInfo?.userType == "INSTITUTE_USER") {
        setUser(result?.data?.body);
        localStorage.setItem(
          STORAGE_KEY.USER_DETAILS,
          JSON.stringify(result?.data?.body)
        );

        if (result?.data?.body?.userInfo?.is_active == false) {
          SHOW_TOAST(t(STRINGS?.your_are_not_institute_user), "warning");
        } else {
          navigate("/home");
        }
      } else {
        SHOW_TOAST(t(STRINGS?.your_are_not_institute_user), "warning");
      }
    } else {
      SHOW_TOAST(t(STRINGS?.user_no_found), "error");
    }
  };
  const handleForgotPassword = () => {
    setForgetPassStatus(true);
    navigate("/forgotpassword");
  };
  return (
    <div className="w-full">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        <Form className="py-4">
          {loginState?.error ? (
            <div className="py-2">
              <Alert message={`${loginState?.error}`} type="error" showIcon />
            </div>
          ) : (
            ""
          )}
          <div className="mb-4">
            <Field
              type="email"
              id="email"
              name="email"
              placeholder={t(STRINGS.email_ID)}
              className="w-full px-2 py-2 rounded-[8px] text-sm font-normal bg-[#EDE7F557] outline-none"
            />
            <ErrorMessage
              name="email"
              component="div"
              className="text-red-500 formik-error text-sm"
            />
          </div>
          <div className="relative mb-2">
            <Field
              type={loginState?.passwordHideShow ? "text" : "password"}
              id="password"
              name="password"
              placeholder={t(STRINGS.password)}
              className="form-control w-full px-2 py-2 text-sm bg-[#EDE7F557] outline-none rounded-[8px]"
            />
            <button
              type="button"
              onClick={() =>
                setLoginState((prev) => ({
                  ...prev,
                  passwordHideShow: !loginState?.passwordHideShow,
                }))
              }
              className="absolute top-0 bottom-0 mr-2 right-0 h-full "
            >
              {loginState?.passwordHideShow ? (
                <IconTint
                  src={IMAGES?.showIcon}
                  color="#B0B0B0"
                  className="text-lg font-medium  w-5 h-auto "
                />
              ) : (
                <IconTint
                  src={IMAGES?.hideIcon}
                  color="#B0B0B0"
                  className="text-lg font-medium  w-5 h-auto "
                />
              )}
            </button>
          </div>
          <ErrorMessage
            name="password"
            component="div"
            className="text-red-500 formik-error text-sm"
          />

          <div className="flex justify-between pb-3 ps-2 text-paragraph">
            <div
              role="button"
              onClick={handleForgotPassword}
              className="cursor-pointer text-[#18605D] text-sm font-medium"
            >
              {t(STRINGS.forget_password)}
            </div>
          </div>

          <AppButton
            btnText={t(STRINGS.log_in)}
            disabled={false}
            className="bg-[#FE6B01] text-white w-full py-2 mt-4 rounded-2xl"
            btnType={"Submit"}
          />
        </Form>
      </Formik>
    </div>
  );
};

export default LoginForm;
